import { createAsyncThunk } from "@reduxjs/toolkit";
import api, { normalizeError } from "../../services/api";

export const sendOtp = createAsyncThunk(
  "auth/sendOtp",
  async ({ phone, purpose }, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/api/auth/send-otp", { phone, purpose });
      return data; // { hash }
    } catch (err) {
      return rejectWithValue(normalizeError(err));
    }
  }
);

export const verifyOtp = createAsyncThunk(
  "auth/verifyOtp",
  async ({ phone, otp, hash, lat, lng }, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/api/auth/verify-otp", { phone, otp, hash, lat, lng });
      return data; // { user }
    } catch (err) {
      return rejectWithValue(normalizeError(err));
    }
  }
);

export const verifyPhone = createAsyncThunk(
  "auth/verifyPhone",
  async ({ phone, otp, hash }, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/api/auth/verify-phone", { phone, otp, hash });
      return data; // { verified: true }
    } catch (err) {
      return rejectWithValue(normalizeError(err));
    }
  }
);

export const checkSession = createAsyncThunk(
  "auth/checkSession",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.get("/api/auth/me");
      return data; // { id, phone, role, createdAt }
    } catch (err) {
      return rejectWithValue(normalizeError(err));
    }
  }
);

export const logout = createAsyncThunk(
  "auth/logout",
  async (_, { rejectWithValue }) => {
    try {
      await api.post("/api/auth/logout");
    } catch (err) {
      return rejectWithValue(normalizeError(err));
    }
  }
);
